export enum INVOICE_FORMAT {
  PDF = 'PDF',
  EHF = 'EHF' // NORWAY ONLY
}
